import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MetaManager from "../Layout/MetaManager"; // ✅ Adjust path if needed
export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(`https://admin.socioloom.com/api/getBlogBySlug.php?slug=${slug}`)
      .then(res => res.json())
      .then(data => setBlog(data));
  }, [slug]);

  if (!blog) return <p className="text-center py-10">Loading...</p>;

  return (
    <>
      <MetaManager slug={slug} />

      <div className='banner-img h-[100%] w-full max-sm:h-[100%]'>

        <div class="custom-shape-divider-bottom-1709136912">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M1200 0L0 0 892.25 114.72 1200 0z" class="shape-fill"></path>
          </svg>
        </div>

        <div className=' flex items-center justify-center h-[100%] w-full flex-col gap-16 max-sm:h-[100%]'>
          <h1 className=' text-5xl font-bold text-white max-sm:text-xl  max-sm:text-center max-md:text-3xl uppercase h1'>{blog.title}</h1>
        </div>
      </div>



<div className="w-full py-10 bg-white">
  <div
    className=" max-w-full text-gray-800 px-4 md:px-10 lg:px-24"
    dangerouslySetInnerHTML={{ __html: blog.content }}
  />
</div>
    </>
  );
}
